/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  CREATE_SHOPEE_PAY_ORDER = '[Order] Create Shopee Pay Order',
  CREATE_SHOPEE_PAY_ORDER_SUCCESS = '[Order] Create Shopee Pay Order Success',
  CREATE_GCASH_PAY_ORDER = '[Order] Create Gcash Pay Order',
  CREATE_GCASH_PAY_ORDER_SUCCESS = '[Order] Create Gcash Pay Order Success',
  GET_ORDER_HISTORY = '[Order] Create Order History',
  GET_ORDER_HISTORY_SUCCESS = '[Order] Create Order History Success',
  RELOAD_ORDER_HISTORY = '[Order] Reload Order History Success',
  CHECK_ORDER_STATUS = '[Order] Check Order Status',
  CHECK_ORDER_STATUS_SUCCESS = '[Order] Check Order Status Success',
  CANCEL_SHOPEEPAY_ORDER = '[Order] Cancel Shopee Pay Order',
  CANCEL_SHOPEEPAY_ORDER_SUCCESS = '[Order] Cancel Shopee Pay Order Success',
  CANCEL_GCASH_ORDER = '[Order] Cancel Gcash Pay Order',
  CANCEL_GCASH_ORDER_SUCCESS = '[Order] Cancel Gcash Order Success',
  CREATE_MAYA_ORDER = '[Order] Create Maya Order',
  CREATE_MAYA_ORDER_SUCCESS = '[Order] Create Maya Order Success',
  CREATE_GETPASS_ORDER = '[Order] Create Getpass Order',
  CREATE_GETPASS_ORDER_SUCCESS = '[Order] Create Getpass Order Success',
}

export const createShopeePayOrder = createAction(
  ActionTypes.CREATE_SHOPEE_PAY_ORDER,
  props<{ data: any, itemType: any }>()
);

export const createShopeePayOrderSuccess = createAction(
  ActionTypes.CREATE_SHOPEE_PAY_ORDER_SUCCESS,
  props<{ data: any, itemType: any }>()
);

export const createGcashOrder = createAction(
  ActionTypes.CREATE_GCASH_PAY_ORDER,
  props<{ data: any, itemType: any }>()
);

export const createGcashOrderSuccess = createAction(
  ActionTypes.CREATE_GCASH_PAY_ORDER_SUCCESS,
  props<{ data: any, itemType: any }>()
);
  
export const getOrderHistory = createAction(
  ActionTypes.GET_ORDER_HISTORY
);

export const reloadOrderHistory = createAction(
  ActionTypes.RELOAD_ORDER_HISTORY
);

export const getOrderHistorySuccess = createAction(
  ActionTypes.GET_ORDER_HISTORY_SUCCESS,
  props<{ data: any }>()
);

export const checkOrderStatus = createAction(
  ActionTypes.CHECK_ORDER_STATUS,
  props<{ data: any }>()
);

export const checkOrderStatusSuccess = createAction(
  ActionTypes.CHECK_ORDER_STATUS_SUCCESS,
  props<{ data: any }>()
);
  
export const cancelShopeePayOrder = createAction(
  ActionTypes.CANCEL_SHOPEEPAY_ORDER,
  props<{ data: any }>()
);

export const cancelShopeePayOrderSuccess = createAction(
  ActionTypes.CANCEL_SHOPEEPAY_ORDER_SUCCESS,
  props<{ data: any }>()
);

export const cancelGcashOrder = createAction(
  ActionTypes.CANCEL_GCASH_ORDER,
  props<{ data: any }>()
);

export const cancelGcashOrderSuccess = createAction(
  ActionTypes.CANCEL_GCASH_ORDER_SUCCESS,
  props<{ data: any }>()
);

export const createMayaOrder = createAction(
  ActionTypes.CREATE_MAYA_ORDER,
  props<{ data: any, itemType: any }>()
);

export const createMayaOrderSuccess = createAction(
  ActionTypes.CREATE_MAYA_ORDER_SUCCESS,
  props<{ data: any, itemType: any }>()
);

export const createGetpassOrder = createAction(
  ActionTypes.CREATE_GETPASS_ORDER,
  props<{ data: any, itemType: any }>()
);

export const createGetpassOrderSuccess = createAction(
  ActionTypes.CREATE_GETPASS_ORDER_SUCCESS,
  props<{ data: any, itemType: any }>()
);